import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  bottomNavigation: {
    background: 'white',
    width: '100%',
    top: 'initial',
    bottom: 0,
    height: 'auto',
    padding: '8px 16px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px -1px 1px rgba(0,0,0,0.13)',
  },
  back: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.dark,
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    paddingRight: 16,
  },
  backIcon: {
    marginRight: 8,
    width: 24,
  },
  bottomButton: {
    width: 172,
    paddingTop: '8px',
    paddingBottom: '8px',
    marginTop: '0px',
    marginBottom: '0px',
  },
}))

export default useStyles
